"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailList = void 0;
var react_1 = __importStar(require("react"));
require("../../../index.css");
var textButton_1 = require("../../action/textButton");
var display_1 = require("../../data/display");
var modal_1 = require("../modal");
var react_md_editor_1 = __importDefault(require("@uiw/react-md-editor"));
var DetailList = /** @class */ (function (_super) {
    __extends(DetailList, _super);
    function DetailList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            visible: false,
            selectedObject: {},
            objectModel: [],
            referenceKey: "",
        };
        _this.handleUpdateReferencePopUpModal = function (visible, selectedObject, referenceKey, objectModel) {
            _this.setState({
                visible: visible,
                selectedObject: selectedObject,
            });
            if (referenceKey) {
                _this.setState({ referenceKey: referenceKey });
            }
            else if (objectModel) {
                _this.setState({ objectModel: objectModel });
            }
            else if (!referenceKey && !objectModel) {
                _this.setState({
                    referenceKey: "",
                    objectModel: [],
                });
            }
        };
        _this.renderBasedOnSchemaType = function (value, model) {
            var _a, _b, _c;
            switch (model.type) {
                case "object":
                    var objectValues = Object.values(value);
                    if (objectValues.length > 0) {
                        return (react_1.default.createElement(react_1.default.Fragment, null,
                            (0, display_1.renderReferenceStringAttribute)(value),
                            ((_a = model.objectData) === null || _a === void 0 ? void 0 : _a.length) !== 0 && (react_1.default.createElement(textButton_1.TextButton, { text: "View", className: "ml-2", onClick: _this.handleUpdateReferencePopUpModal.bind(_this, true, value, "", model.objectData) }))));
                    }
                    else
                        return react_1.default.createElement(react_1.default.Fragment, null, " - ");
                case "reference":
                    var displayValue = (_c = value[(_b = model.referenceLabel) !== null && _b !== void 0 ? _b : ""]) !== null && _c !== void 0 ? _c : (0, display_1.renderReferenceStringAttribute)(value);
                    var displayReferenceObject = value;
                    return (react_1.default.createElement(react_1.default.Fragment, null,
                        displayValue,
                        !_this.props.hideModal &&
                            typeof displayReferenceObject !== "string" && (react_1.default.createElement(textButton_1.TextButton, { text: "View", className: "ml-2", onClick: _this.handleUpdateReferencePopUpModal.bind(_this, true, value, model.id) }))));
                case "markdown":
                    return (react_1.default.createElement(react_md_editor_1.default.Markdown, { source: value, wrapperElement: { "data-color-mode": "light" }, className: "no-tailwind", 
                        // INFO : Disble header link
                        rehypeRewrite: function (node, _index, parent) {
                            if (node.tagName === "a" &&
                                parent &&
                                /^h(1|2|3|4|5|6)/.test(parent.tagName)) {
                                parent.children = parent.children.slice(1);
                            }
                        } }));
                default:
                    return (0, display_1.renderEachRowDataBasedOnDataType)(value);
            }
        };
        _this.renderReferenceDetail = function () {
            var _a, _b;
            if (_this.state.selectedObject) {
                var detailList = [];
                var _loop_1 = function (eachKey, eachValue) {
                    if (eachKey !== "id" &&
                        eachKey !== "_id" &&
                        eachKey !== "baseUpdatedAt" &&
                        eachKey !== "baseDraft") {
                        var filterModel = void 0;
                        var searchModel = _this.state.objectModel.length > 0
                            ? _this.state.objectModel
                            : _this.props.referenceModel
                                ? _this.props.referenceModel
                                : [];
                        if (searchModel) {
                            var model = _this.state.objectModel.length > 0
                                ? JSON.parse(JSON.stringify(searchModel))
                                : JSON.parse(JSON.stringify(searchModel[_this.state.referenceKey]));
                            filterModel = model.find(function (eachAttribute) {
                                return eachAttribute.id === eachKey;
                            });
                        }
                        if (filterModel && eachValue && eachValue.length > 0) {
                            detailList.push({
                                title: filterModel.name,
                                text: eachValue,
                            });
                        }
                    }
                };
                for (var _i = 0, _c = Object.entries(_this.state.selectedObject); _i < _c.length; _i++) {
                    var _d = _c[_i], eachKey = _d[0], eachValue = _d[1];
                    _loop_1(eachKey, eachValue);
                }
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(DetailList, { list: detailList, title: "Details", hideModal: true, model: _this.state.objectModel.length > 0
                            ? _this.state.objectModel
                            : _this.props.referenceModel
                                ? _this.props.referenceModel[_this.state.referenceKey]
                                : [], lib: {
                            Dialog: (_a = _this.props.lib) === null || _a === void 0 ? void 0 : _a.Dialog,
                            Transition: (_b = _this.props.lib) === null || _b === void 0 ? void 0 : _b.Transition,
                        } })));
            }
            return null;
        };
        return _this;
    }
    DetailList.prototype.render = function () {
        var _this = this;
        var _a, _b, _c;
        var defaultCss = "overflow-hidden ";
        if (this.props.className) {
            defaultCss += this.props.className;
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            ((_a = this.props.lib) === null || _a === void 0 ? void 0 : _a.Dialog) && this.props.lib.Transition && (react_1.default.createElement(modal_1.Modal, { open: this.state.visible, lib: {
                    Dialog: (_b = this.props.lib) === null || _b === void 0 ? void 0 : _b.Dialog,
                    Transition: (_c = this.props.lib) === null || _c === void 0 ? void 0 : _c.Transition,
                }, renderContent: this.renderReferenceDetail, onClose: this.handleUpdateReferencePopUpModal.bind(this, false, {}) })),
            react_1.default.createElement("div", { className: defaultCss },
                react_1.default.createElement("div", { className: "px-4 py-5 sm:px-6" },
                    react_1.default.createElement("h3", { className: "font-medium leading-6 text-gray-900 text-md sm:text-lg" }, this.props.title),
                    this.props.description && (react_1.default.createElement("p", { className: "max-w-2xl mt-1 text-sm text-gray-500 whitespace-pre-line break-words" }, this.props.description))),
                react_1.default.createElement("div", { className: "px-4 py-5 border-t border-gray-200 sm:p-0" },
                    react_1.default.createElement("dl", { className: "sm:divide-y sm:divide-gray-200" }, this.props.list.map(function (eachList, index) {
                        var filterModel = _this.props.model
                            ? _this.props.model.find(function (eachAttribute) {
                                return (eachAttribute.name === eachList.title &&
                                    eachAttribute.type !== "listObject");
                            })
                            : null;
                        if (_this.props.model && !filterModel)
                            return null;
                        return (react_1.default.createElement("div", { key: index + eachList.text, className: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" },
                            react_1.default.createElement("dt", { className: "text-sm font-medium text-gray-500" }, eachList.title),
                            react_1.default.createElement("dd", { className: "mt-1 text-sm text-gray-900 whitespace-pre-line break-words sm:mt-0 sm:col-span-2" }, filterModel
                                ? _this.renderBasedOnSchemaType(eachList.text, filterModel)
                                : (0, display_1.renderEachRowDataBasedOnDataType)(eachList.text))));
                    }))))));
    };
    return DetailList;
}(react_1.Component));
exports.DetailList = DetailList;
//# sourceMappingURL=index.js.map